import { GoTrash } from 'react-icons/go'
import { useState } from "react";
import { useCadastro } from "../../../../../../context/CadastroContext";
import { useModal } from "../../../../../../hooks/ModalContext";
import { Button } from "../../../../../generics/button";
import { ModalErro } from '../../../erro'

interface Horario {
  dia: string;
  horainicial: string;
  horafinal: string;
}

export const HorarioModal = () => {
  const diasSemana = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo']
  const defaultHora = [
    {
      dia: '10',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '9',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '8',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '1',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '2',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '3',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '4',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '5',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '6',
      horafinal: '',
      horainicial: ''
    },
    {
      dia: '7',
      horafinal: '',
      horainicial: ''
    }
  ]

  const [horarios, setHorarios] = useState<Horario[]>(defaultHora)

  const { getMelhoresHorarios, deleteMelhorHoario } = useCadastro()
  const { telefone, setModal } = useModal()


  function handleHorario(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, id, value } = e.target
    const tag = id.includes('inicial') ? 'horainicial' : 'horafinal'
    let mudanca = horarios.find(item => item.dia === name)
    let hor = horarios.filter(item => item.dia !== name)
    if (value && mudanca) {
      setHorarios([...hor, {
        ...mudanca,
        [tag]: value
      }])
    }
  }

  function formatHora(tempo: string) {
    const [hora, minuto] = tempo.split(':')
    return `${hora}:${minuto}`
  }

  function verificarPreenchimento(obj: Horario) {
    const valores = Object.values(obj);
    const todosPreenchidos = valores.every(valor => valor !== '');
    const camposNaoPreenchidos = (obj.horainicial === '' && obj.horafinal !== '') || (obj.horafinal === '' && obj.horainicial !== '');

    if (todosPreenchidos) {
      return obj;
    } else if (camposNaoPreenchidos) {
      setModal('Erro horário nao preenchido', 'Erro', false, true);
      return
    } else {
      return;
    }
  }

  function getMaisHorarios(obj: Horario, qtdDias: number) {
    let horas: Horario[] = []

    for (let index = 0; index < qtdDias; index++) {
      horas.push({
        dia: `${index + 1}`,
        horafinal: obj.horafinal,
        horainicial: obj.horainicial
      })
    }

    return horas
  }


  function handleSubmit() {
    const h = horarios.find(item => item.dia === '10' && item.horafinal !== '' && item.horainicial !== '')
    const o = horarios.find(item => item.dia === '9' && item.horafinal !== '' && item.horainicial !== '')
    const r = horarios.find(item => item.dia === '8' && item.horafinal !== '' && item.horainicial !== '')

    let data: Horario[]
    if (h) {
      data = getMaisHorarios(h, 7)
    } else if (o) {
      data = getMaisHorarios(o, 6)
    } else if (r) {
      data = getMaisHorarios(r, 5)
    } else {
      const array = horarios.map(horas => {
        const h = verificarPreenchimento(horas) as Horario
        return h
      })
      data = array.filter((elemento) => {
        return elemento !== undefined;
      });
    }
    getMelhoresHorarios(data, telefone.telefone)
    setHorarios(defaultHora)
  }

  function findValue(dia: string, tag: 'horainicial' | 'horafinal') {
    const hora = horarios.find(item => item.dia === dia)
    return hora ? hora[tag] : '00:00'
  }

  return (
    <div className="my-2">
      <div className="grid w-full grid-cols-[1fr_1fr]">
        {/* Grid de cadastro */}
        <div>
          <div className="grid-horario text-center">
            <strong className="text-left">Dias da semana</strong>
            <strong>Inicial</strong>
            <strong>Final</strong>
          </div>
          <div className="grid-horario">
            <p>Todos os dias</p>
            <input type="time" className="input-horario" id="tds-inicial" value={findValue('10', 'horainicial')} name="10" onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="tds-final" value={findValue('10', 'horafinal')} name="10" onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Seg à Sáb</p>
            <input type="time" className="input-horario" id="seg-sab-inicial" value={findValue('9', 'horainicial')} name="9" onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="seg-sab-final" name="9" value={findValue('9', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Seg à Sex</p>
            <input type="time" className="input-horario" id="seg-sex-inicial" name="8" value={findValue('8', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="seg-sex-final" name="8" value={findValue('8', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>

          <div className="grid-horario">

            <p>Segunda</p>
            <input type="time" className="input-horario" id="seg-inicial" name="1" value={findValue('1', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="seg-final" name="1" value={findValue('1', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Terça</p>
            <input type="time" className="input-horario" id="ter-inicial" name="2" value={findValue('2', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="ter-final" name="2" value={findValue('2', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Quarta</p>
            <input type="time" className="input-horario" id="qua-inicial" name="3" value={findValue('3', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="qua-final" name="3" value={findValue('3', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Quinta</p>
            <input type="time" className="input-horario" id="qui-inicial" name="4" value={findValue('4', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="qui-final" name="4" value={findValue('4', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Sexta</p>
            <input type="time" className="input-horario" id="sex-inicial" name="5" value={findValue('5', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="sex-final" name="5" value={findValue('5', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Sábado</p>
            <input type="time" className="input-horario" id="sab-inicial" name="6" value={findValue('6', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="sab-final" name="6" value={findValue('6', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
          <div className="grid-horario">

            <p>Domingo</p>
            <input type="time" className="input-horario" id="dom-inicial" name="7" value={findValue('7', 'horainicial')} onChange={(e) => { handleHorario(e) }} />
            <input type="time" className="input-horario" id="dom-final" name="7" value={findValue('7', 'horafinal')} onChange={(e) => { handleHorario(e) }} />
          </div>
        </div>

        {/* Botões para adicionar e remover horários */}
        {/* <div className="flex h-full flex-col items-center justify-center gap-4">
          <button className="h-10 w-10 rounded bg-primary text-center text-2xl font-medium text-white">
            +
          </button>
          <button className="h-10 w-10 rounded bg-primary text-center text-2xl font-medium text-white">
            -
          </button>
        </div> */}

        {/* Tabela de horários cadastrados  */}
        <div className="rounded bg-gray-300 p-2">
          <div className="mb-2 grid grid-cols-[1fr_70px_40px_70px_40px]  place-items-center  text-sm font-medium">
            <p>Dias da semana</p>
            <p>Inicial</p>
            <p></p>
            <p>Final</p>
          </div>
          <div className="h-[91%] rounded bg-white ">
            {
              telefone?.melhoreshorarios?.melhorhorario && telefone?.melhoreshorarios?.melhorhorario.length > 0 && telefone?.melhoreshorarios?.melhorhorario.map(horas => (
                <div className="grid-horario-tabela rounded-t-md my-1">
                  <p>{diasSemana[Number(horas.dia) - 1]}</p>
                  <p>{formatHora(horas.horainicial)}</p>
                  <p>às</p>
                  <p>{formatHora(horas.horafinal)}</p>
                  <button type="button" onClick={() => deleteMelhorHoario(horas.dia, telefone.telefone)}>
                    <GoTrash size={20} className="fill-error" />
                  </button>
                </div>
              ))
            }

          </div>
        </div>
      </div>
      <div className="mt-4 w-full flex justify-end ml-3">
        <Button name="Salvar" type="button" width="w-[30%]" onClick={() => handleSubmit()} />
      </div>

      <ModalErro message='Horário não preenchido corretamente!' />

    </div>
  );
};
